// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"30d64685","949":"30d64685"}[chunkId] + ".chunk.css";
};